<script lang="ts">
	import { SidepanelContent } from '@Shelly/shelly-design-system';
	import EventLog from 'src/components/EventLog/EventLog.svelte';

	export let list = [];
</script>

<SidepanelContent>
	<EventLog devicesArr={list} type="group" />
</SidepanelContent>
